import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';
import { AllocationMode } from '../../constants/allocationMode';
import { useAddClientAllocationContext } from '../context/AddClientAllocationContext';
import AllocationClientsList from './AllocationsList/AllocationClientsList';
import AllocationClientsListGU from './AllocationsList/AllocationClientsListGU';
import AllocationLocationGroupsList from './AllocationsList/AllocationLocationGroupsList';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AssignedClients: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { allocationMode, currentUserRole } = useAddClientAllocationContext();

  if (allocationMode === AllocationMode.BY_LOCATION_GROUP) {
    return <AllocationLocationGroupsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
  }

  if (currentUserRole.isGlobalUser) {
    return <AllocationClientsListGU teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
  }

  return <AllocationClientsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
};

export default AssignedClients;
